import gql from 'graphql-tag';
import { QUALITY_REPORT_SELECTION } from '@/store/qualityReportSelection';
import { REPORT_TEMPLATE_IMAGE_REQUEST_FIELDS } from '@/store/reportTemplateImages';
import { ATTACHMENT_FIELDS } from './projectDocumentsFragment';
import { PROJECT_QUALITY_REPORT_PHOTO_FIELDS } from './projectQualityReportFields';

const PHOTO_LIST_SELECTION = PROJECT_QUALITY_REPORT_PHOTO_FIELDS.map(
  (field) => `${field} { ${ATTACHMENT_FIELDS} }`
).join('\n');

/**
 * Data of the block project-quality-report-data ("Qualitätsprotokoll: Erfasste Daten"): the cards
 * (`qualityReport`), the roof type the cards branch on and the roof type card sets, the photo
 * lists of the cards and the template images of the cards. Read through
 * `Project.blocks.qualityReportData`, which checks the block's read permission.
 */
export const PROJECT_QUALITY_REPORT_DATA_FIELDS = gql`
  fragment projectQualityReportDataFields on ProjectQualityReportDataBlock {
    id
    number
    qualityReport {
      ${QUALITY_REPORT_SELECTION}
    }
    measurement {
      roofType
    }
    ${PHOTO_LIST_SELECTION}
    reportTemplateImages {
      ...reportTemplateImageFields
    }
  }
  ${REPORT_TEMPLATE_IMAGE_REQUEST_FIELDS}
`;
